import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { rgba } from 'polished';
import {
    Colours,
    Sizes,
    Typography,
    IconExclamationMark,
    Caption,
} from '@ratehub/base-ui';


function ErrorBanner({ title, ...otherProps }) {
    return (
        <ErrorBanner.FlexContainer {...otherProps}>
            <ErrorBanner.IconExclamationMark
                width={Sizes.ICONS.XS}
                height={Sizes.ICONS.XS}
                stroke={Colours.COCONUT}
                outlineWidth="4"
            />
            <ErrorBanner.Title variant="light">
                {title}
            </ErrorBanner.Title>
        </ErrorBanner.FlexContainer>   
    );
}

ErrorBanner.propTypes = {
    title: PropTypes.string.isRequired,
};


ErrorBanner.FlexContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
    padding: ${Sizes.SPACING.HALF};
    background-color: ${rgba(Colours.STRAWBERRY, 0.97)};
`;

ErrorBanner.Title = styled(Caption)`
    margin: 0;
    text-align: left;
    font-weight: ${Typography.WEIGHTS.MEDIUM};
`;

ErrorBanner.IconExclamationMark = styled(IconExclamationMark)`
    flex: ${Sizes.SPACING.TWO_AND_A_HALF} 0 0;
    stroke-width: 4;
`;


export default observer(ErrorBanner);